const SectionCorporateOffer = Class(
	/**
	 * @lends {SectionCorporateOffer#}
	 */
	{
		__NAME: 'SectionCorporateOffer',

		background: null,
		bodyClass: 'small-nav',
		menuItem: 'corporate',

		__construct() {
			this.node = mkE({
				tag: 'div',
				id: 'SectionCorporateOffer'
			}).append(this.layout.ct());
		},

		draw() {
			new T.Hero({
				className: 'hero-simple',
				backgroundClass: `background-picture-corporate-offer`,
				title: mkE({
					tag: 'span',
					innerHTML: D.Lang.get('corporate-offer.welcome.title')
				}),
				text: D.Lang.get('corporate-offer.welcome.text')
			}).append(this.node);

			mkE({
				tag: 'div',
				className: 'corporate-form-wrapper',
				els: [
					{
						tag: 'div',
						className: 'corporate-contact-us container',
						els: [
							{
								tag: 'div',
								className: 'bs-row',
								els: [
									{
										tag: 'div',
										className: 'col-12 col-md-6',
										els: [
											{
												tag: 'div',
												className: 'banner',
												els: [
													{
														tag: 'div',
														className: 'headline',
														text: D.Lang.get('corporate-offer.banner.headline')
													},
													{
														tag: 'div',
														className: 'text',
														innerHTML: D.Lang.get('corporate-offer.banner.text')
													}
												]
											}
										]
									},
									{
										tag: 'div',
										className: 'col-12 col-md-6',
										els: [
											new SectionCorporateOffer.Form()
										]
									}
								]
							},
							{
								tag: 'div',
								className: 'corporate-form-interested',
								els: [
									{
										tag: 'div',
										className: 'bs-row',
										els: [
											{
												tag: 'div',
												className: 'col-12 col-md-6',
												els: [
													{
														tag: 'div',
														className: 'corporate-contacts-title-caption',
														text: D.Lang.get('corporate-form.caption')
													},
													{
														tag: 'h2',
														className: 'h1',
														text: D.Lang.get('corporate-form.title')
													}
												]
											},
											{
												tag: 'div',
												className: 'col-12 col-md-6',
												els: [
													{
														tag: 'div',
														className: 'corporate-contacts-box',
														els: [
															{
																tag: 'div',
																className: 'caption',
																text: D.Lang.get('corporate-form.drop-line')
															},
															{
																tag: 'a',
																href: 'mailto:davis@roadgames.com',
																className: 'mail',
																text: 'davis@roadgames.com'
															}
														]
													}
												]
											}
										]
									},
									{
										tag: 'div',
										className: 'bs-row',
										els: [
											{
												tag: 'div',
												className: 'col-12',
												els: [
													{
														tag: 'div',
														className: 'form-disclaimer',
														els: [
															D.Lang.get('corporate-form.personal-data'),
															' ',
															{
																tag: 'a',
																text: D.Lang.get('corporate-form.privacy-policy'),
																target: '_blank',
																href: D.url('privacy-policy')
															}
														]
													}
												]
											}
										]
									}
								]
							}
						]
					}
				]
			}).append(this.node);

			this.ready();
		}
	},
	Section
);

SectionCorporateOffer.Form = Class(
	/**
	 * @lends {SectionCorporateOffer.Form#}
	 */
	{
		__construct() {
			this._fields = {};
			this.node = mkE({
				tag: 'form',
				className: 'corporate-contacts-form bs-form',
				method: 'post',
				onsubmit: this._onSubmit,
				els: [
					{
						tag: 'h2',
						text: D.Lang.get('corporate-offer-form.h2')
					},
					{
						tag: 'div',
						className: 'corporate-contacts-block',
						els: [
							{
								tag: 'div',
								className: 'corporate-contacts-caption',
								text: D.Lang.get('corporate-form.personal-info')
							},
							{
								tag: 'div',
								className: 'bs-row',
								els: [
									{
										tag: 'div',
										className: 'col-12 col-md-6',
										els: [
											this._fields['full_name'] = new T.BS.Input({
												label: D.Lang.get('corporate-form.name'),
												name: 'full_name',
												placeholder: D.Lang.get('corporate-form.name.placeholder'),
												required: true
											})
										]
									},
									{
										tag: 'div',
										className: 'col-12 col-md-6',
										els: [
											this._fields['phone'] = new T.BS.Input({
												label: D.Lang.get('corporate-form.phone'),
												name: 'phone_default',
												type: 'tel',
												phone: {
													hiddenInput: 'phone',
													preferredCountries: D.Lang.get('corporate-form.phone.preffered').split(',')
												},
												required: true
											})
										]
									}
								]
							},
							{
								tag: 'div',
								className: 'bs-row',
								els: [
									{
										tag: 'div',
										className: 'col-12',
										els: [
											this._fields['email'] = new T.BS.Input({
												label: D.Lang.get('corporate-form.email'),
												name: 'email',
												type: 'email',
												attr: {
													placeholder: D.Lang.get('corporate-form.email.placeholder')
												},
												required: true
											})
										]
									}
								]
							},
							{
								tag: 'div',
								className: 'corporate-contacts-form-special',
								text: D.Lang.get('corporate-offer-form.special')
							}
						]
					},
					{
						tag: 'div',
						className: 'bs-row corporate-contacts-bottom',
						els: [
							{
								tag: 'div',
								className: 'col-12',
								els: [
									{
										tag: 'div',
										className: 'form-button',
										els: [
											{
												tag: 'button',
												className: 'button button-pink',
												text: D.Lang.get('corporate-form.send')
											},
											this._formMessage = mkE({
												tag: 'div',
												className: 'form-message'
											})
										]
									}
								]
							}
						]
					}
				]
			});
		},

		clearForm() {
			this.node.reset();
		},

		showSuccess() {
			mkE.appendTypeElement(this._formMessage, [
				D.Lang.get('corporate-form.thanks'),
				{tag: 'br'},
				D.Lang.get('corporate-form.thanks.extra')
			]);
		},

		showError( response ) {
			if( response.errors ) {
				let hasError = false;
				if( response.errors.full_name ) {
					this._fields['full_name'].error(D.Lang.get('corporate-form.errors.name'));
					hasError = true;
				}
				if( response.errors.phone ) {
					this._fields['phone'].error(D.Lang.get('corporate-form.errors.phone'));
					hasError = true;
				}
				if( response.errors.email ) {
					this._fields['email'].error(D.Lang.get('corporate-form.errors.email'));
					hasError = true;
				}
				if( hasError ) {
					this._scrollToError();
					return;
				}
			}
			alert(D.Lang.get('corporate-form.errors.default'));
		},

		_onSubmit() {
			if( this._isSubmitting ) {
				return false;
			}
			clearNode(this._formMessage);
			this._isSubmitting = true;
			let hasError = false;
			let values = {};
			for( const field in this._fields ) {
				this._fields[field].error(null);
				values[field] = this._fields[field].value();
			}
			if( !values.full_name ) {
				this._fields['full_name'].error(D.Lang.get('corporate-form.errors.name'));
				hasError = true;
			}
			if( !values.phone ) {
				this._fields['phone'].error(D.Lang.get('corporate-form.errors.phone'));
				hasError = true;
			}
			if( !values.email ) {
				this._fields['email'].error(D.Lang.get('corporate-form.errors.email'));
				hasError = true;
			}
			if( hasError ) {
				this._isSubmitting = false;
				this._scrollToError();
				return false;
			}
			let data = new FormData();
			for( const field in values ) {
				if( !values.hasOwnProperty(field) ) {
					continue;
				}
				data.append(field, values[field]);
			}
			data.append('json', '1');
			fetch("/api/corporate_offer.php", {
				body: data,
				method: 'POST'
			})
				.then(response => response.json())
				.then(response => {
					this._isSubmitting = false;
					if( response.error ) {
						this.showError(response);
						return;
					}
					this.showSuccess();
					this.clearForm();
				})
				.catch(error => {
					this._isSubmitting = false;
					alert(D.Lang.get('corporate-form.errors.default'));
				});
			return false;
		},

		_scrollToError() {
			let error = this.node.querySelector(".invalid-feedback:not(:empty)").closest(".form-group");
			if( error ) {
				D.scrollIntoView(error);
			}
		}
	},
	mkE.Base
)